import PropTypes from "prop-types"
import React from "react"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "assets/images/favicon.png"
import logoDark from "assets/images/logotop.png"
import logoLightSvg from "assets/images/favicon.png"
import logoLightPng from "assets/images/logotop.png"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="#" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="20" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="65" />
            </span>
          </Link>

          <Link to="#" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="20" />
            </span>
            <span className="logo-lg">
              <img src={logoLightPng} alt="" height="65" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          <SidebarContent />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}
export default withRouter(withTranslation()(Sidebar))
